(ns practitest.frontend.landing.main
  (:require [practitest.frontend.landing.views :as views]
            [practitest.frontend.landing.subs]
            [practitest.frontend.landing.events]
            [re-frame.core :as re-frame]))

(defn landing-view []
  [views/main-panel])

(def main-controller
  {:start (fn [_params]
            (re-frame/dispatch [:landing/init]))})
